
import { storeToRefs } from 'pinia';
import { computed } from '@vue/composition-api';
import { useLocationStore } from '~/store/location';
import type { Availability } from '~/type/product/Product';
const __sfc_main = {};
__sfc_main.props = {
  availability: {
    key: "availability",
    required: true,
    type: Array
  },
  title: {
    key: "title",
    required: false,
    type: String,
    default: 'Наличие товара в вашем городе'
  }
};
__sfc_main.setup = (__props, __ctx) => {
  const props = __props;
  const {
    currentCity
  } = storeToRefs(useLocationStore());
  const isCurrentCityAvailable = computed(() => props.availability.some(el => el.cityId === currentCity.value?.id));
  const currentCityStoreList = computed(() => props.availability.filter(el => el.cityId === currentCity.value?.id));
  const anotherCityStoreList = computed(() => props.availability.filter(el => el.cityId !== currentCity.value?.id).sort((a, b) => a.cityId - b.cityId));
  return {
    isCurrentCityAvailable,
    currentCityStoreList,
    anotherCityStoreList
  };
};
export default __sfc_main;
